import { environment } from '../../environments/environment';
export { environment } from '../../environments/environment';
export function GetV5CoreApiUrl(path, params) {
    var v5CorePrefix = environment.microserviceApiV5Core;
    var url = environment.apiHost + v5CorePrefix + path;
    if (params instanceof Object) {
        url += '?';
        Object.entries(params).forEach(function (_a) {
            var param = _a[0], value = _a[1];
            url += encodeURIComponent(param) + "=" + encodeURIComponent(value) + "&";
        });
    }
    return url;
}
